import { buildAnimationClasses, isWaveIdle } from './useWidgetAnimation';

export function StaticTextWidget({ fields }: { fields: Record<string, unknown> }) {
  const text = String(fields.text ?? '');
  const fontSize = Number(fields.fontSize ?? 32);
  const color = String(fields.color ?? '#ffffff');
  const { className, style } = buildAnimationClasses(fields);

  // Wave idle needs per-character spans with a staggered animation-delay
  // so each letter rises in sequence. For every other animation the text
  // renders as a single string so font kerning + ligatures look natural.
  const wave = isWaveIdle(fields);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        textAlign: 'center',
      }}
    >
      <div
        className={className}
        style={{
          ...style,
          color,
          fontSize,
          fontFamily: 'system-ui, sans-serif',
          fontWeight: 700,
          lineHeight: 1.1,
        }}
      >
        {wave ? splitChars(text) : text}
      </div>
    </div>
  );
}

function splitChars(text: string): React.ReactNode {
  // Stagger the wave 60ms per character. Spaces collapse without animation
  // so the cadence stays even.
  const out: React.ReactNode[] = [];
  for (let i = 0; i < text.length; i++) {
    const ch = text[i]!;
    if (ch === ' ') {
      out.push(<span key={i}>&nbsp;</span>);
      continue;
    }
    out.push(
      <span
        key={i}
        className="hv-char"
        style={{ ['--hv-char-delay' as string]: `${i * 60}ms` } as React.CSSProperties}
      >
        {ch}
      </span>,
    );
  }
  return out;
}
